import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Pagination {
  limit?: number
  page?: number
}

interface Order {
  pagination: Pagination
  setPagination: (pagination: Pagination) => void
}

const useStoreBase = create<Order>()((set) => ({
  pagination: { page: 0, limit: 100 },
  setPagination: (pagination: Pagination) => set(() => ({ pagination }))
}))

export const useTableStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
